module.exports = __webpack_public_path__ + "static/media/AppStoreButton.4f1ec00d.svg";